module.exports = __webpack_public_path__ + "fonts/2CZUJpAe.woff2";